<div class="scrollable" #scroll>
  <ng-content></ng-content>
</div>
